module.exports = __webpack_public_path__ + "rf1-8843dcf30836e60ce88b120570ad9705.jpg";


//////////////////
// WEBPACK FOOTER
// ./client/app/assets/images/rf1.jpg
// module id = 1CXG
// module chunks = client